export default __webpack_public_path__ + "static/media/fireflink-assets-white.800f241f.svg";